import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingTable } from './components/PricingTable';
import { Accelerator } from './components/Accelerator';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
import { BottomPricing } from './components/BottomPricing';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '980793120943222');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=980793120943222&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  const testimonials1 = [{
    initials: 'MG',
    name: 'Mariela G.',
    location: 'Córdoba',
    text: 'Lancé un jueves con el Círculo de Confianza y el sábado ya entregué 3 desayunos. La planilla de costos del Tomo 3 me salvó de perder plata.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    text: 'El Método Boutique es increíble. Pasé de cobrar muy poco a cobrar lo que verdaderamente merezco'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    text: 'Tenía miedo por los aumentos en el súper, pero el Ritual de los Lunes me da una tranquilidad total. Sé exactamente cuánto gano en cada caja.'
  }];
  const testimonials2 = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    text: 'El sistema de seña me salvó. Antes me cancelaban a las 7 am y me quedaba con la mercadería. Ahora, con reglas claras, hasta los clientes me respetan más.'
  }, {
    initials: 'PS',
    name: 'Pilar S.',
    location: 'Buenos Aires',
    text: 'Las 120 frases para tarjetas son increíbles. Los clientes siempre me dicen "qué bien que escribís". No saben que saco todo del kit.'
  }, {
    initials: 'DO',
    name: 'Daniel O.',
    location: 'Salta',
    text: 'El Tomo 5 de fotos cambió mi Instagram. Con una cartulina blanca y luz de ventana mis fotos parecen de estudio.'
  }];
  return <div className="min-h-screen bg-dark text-white selection:bg-brand selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials testimonials={testimonials1} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Bonuses data-id="element-6" />

      <section className="py-12 px-4 text-center bg-dark-card border-y border-dark-border" data-id="element-7">
        <div className="max-w-3xl mx-auto" data-id="element-8">
          <div className="text-brand font-bold mb-4 tracking-widest text-sm" data-id="element-9">
            ⏰ PRECIO DE LANZAMIENTO CIERRA EN:
          </div>
          <CountdownTimer data-id="element-10" />
          <div className="mt-4 flex items-center justify-center space-x-2" data-id="element-11">
            <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-12" />
            <span className="text-sm text-gray-400" data-id="element-13">
              Quedan pocos cupos al precio de lanzamiento
            </span>
          </div>
          <div className="w-full max-w-md mx-auto h-2 bg-dark rounded-full mt-4 overflow-hidden" data-id="element-14">
            <div className="h-full bg-brand w-[72%]" data-id="element-15" />
          </div>
          <div className="text-xs text-gray-500 mt-2" data-id="element-16">
            72% de los cupos ya tomados
          </div>
        </div>
      </section>

      <PricingTable data-id="element-17" />
      <Accelerator data-id="element-18" />

      <div className="py-12 pt-[15px] pb-[15px]" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-3xl font-black" data-id="element-21">
            ❤️ MÁS EMPRENDEDORES QUE YA LO TIENEN
          </h2>
        </div>
        <Testimonials testimonials={testimonials2} data-id="element-22" />
      </div>

      <Guarantee data-id="element-23" />
      <FAQ data-id="element-24" />
      <CostSection data-id="element-25" />

      <BottomPricing data-id="element-26" />

      <Footer data-id="element-27" />
    </div>;
}